import Chart from 'chart.js/auto';

jQuery(document).on('gform_confirmation_loaded', function(event, formId) {

  let scores = 0;
  let benchmark = 0;
  const dataDiv = document.getElementById('chartdata')

  scores = JSON.parse('[' + dataDiv.dataset.scores + ']');
  benchmark = JSON.parse('[' + dataDiv.dataset.benchmark + ']');

  const ctx = document.getElementById('psChart');
  const labels = ['Q1', 'Q2', 'Q3', 'Q4', 'Q5', 'Q6', 'Q7', 'Q8', 'Q9', 'Q10'];

  const data = {
    labels: labels,
    datasets: [{
        label: 'Your score',
        data: scores,
        backgroundColor: '#e6005b',
      },
      {
        label: 'Industry benchmark',
        data: benchmark,
        backgroundColor: '#f59c01',
      }
    ]
  };

  new Chart(ctx, {
    type: 'bar',
    data: data,
    options: {
      legend: {
        display: true,
        position: 'right', // This aligns the legend to the right
        align: 'end', // This also aligns the legend to the right (for older Chart.js versions)
      }
    },
  });
});